import * as React from "react";

export  default function ScanQrCode ({showModal, setShowModal}) {
    return (
        <>
            {showModal ?
                <div style={{display: "flex"}}>
                    <div>
                        <div className="modal-scan-wrapper">
                            <div className="padding-small">
                                <div
                                    className="modal-scan-imgwrap"><img
                                    src="/assets/images/common/download-qr.svg"
                                    loading="lazy" alt="changex qr code"></img></div>
                                <div
                                    className="modal-scan-heading max-width-small"><h3
                                    className="heading-style-h5 margin-vertical margin-small">Scan to Download Changex</h3>
                                </div>
                                <button
                                    name="close"
                                    onClick={() => setShowModal(prev => !prev)} style={{opacity: 1}}
                                    className="button is-secondary gray max-width-full w-inline-block">
                                    <div>
                                        Close
                                    </div>
                                </button>
                            </div>
                            <button
                                name="open"
                                aria-label="close"
                                onClick={() => setShowModal(prev => !prev)}
                                className="close-link w-inline-block">
                                <img
                                    src="/assets/images/common/icn-close.svg"
                                    width="16"
                                    height="16"
                                    loading="lazy"
                                    alt="changex qr code dowbload">
                                </img>
                            </button>
                        </div>
                    </div>
                </div>
                : null}
        </>
    )
}
